

import Vue from 'vue'
import Component from "vue-class-component";

import LoginDialog from "@/components/auth/LoginDialog.vue";
import LeftNav from "@/components/LeftNav.vue";
import NotificationTemplate from "@/components/NotificationTemplate.vue";
import FieldEditor from "@/components/shared/FieldEditor.vue";
import {IErrors} from "@/model/IErrors";

const packageJson = require('../package.json');

const NOTIFICATION_TIME = 5000
const EMAIL_FEEDBACK_TIME = 2200

  @Component({
    components: {
      LoginDialog,
      LeftNav,
      FieldEditor,
      NotificationTemplate,
    }
  })
  export default class App extends Vue {
    private emailSendFeedback = {
      show:   false,
      type:   'success',
      icon:   'mdi-email-check-outline',
      title:  '',
      detail: '',
    };
    private emailSendFeedbackTimer: number | null = null;
    private readonly emailSendMutationNames = [
      'emailComposed',
      'emailForwarded',
      'emailReplied',
      'emailSent',
      'templateReplySent',
    ];

    get drawerMiniVariant() {
      // @ts-ignore
      const w = this.windowWidth;
      const isXs = w < 667;
      // @ts-ignore
      const miniVariant = this.miniVariant;
      return isXs || miniVariant;
    }

    get packageVersion() {
      return packageJson.version;
    }

    get packageDescription() {
      return packageJson.description;
    }

    get currentYear() {
      return new Date().getFullYear();
    }

    get usesSimpleLayout() {
      return Boolean(this.$route && this.$route.meta && this.$route.meta.simpleLayout);
    }

    created() {
      this.$uiBus.on("alert", this.onAlert);
      this.$uiBus.on("success", this.onSuccess);
      this.$uiBus.on("info", this.onInfo);
      this.$uiBus.on("backend.call.OK", this.onBackendCallOK);
      this.$uiBus.on("backend.call.KO", this.onBackendCallKO);
    }

    beforeDestroy() {
      this.$uiBus.off("backend.call.OK", this.onBackendCallOK);
      this.$uiBus.off("backend.call.KO", this.onBackendCallKO);
    }

    onAlert(title: string, message: string) {
      this.$notify({
        title,
        text: message,
        type: 'error',
        duration: NOTIFICATION_TIME,
        data: {
          to: null,
        }
      });
    }

    get headerFooterColor() {
     if (window.location.href.includes('local')) {
       return '#FF647C';
     }
     else if (window.location.href.includes('s2')) {
       return '#FAB314';
     }
     else {
       return '#607D8B';
     }
    }

    onSuccess(title: string, message: string, to: string) {
      this.$notify({
        title,
        text: message || '',
        duration: NOTIFICATION_TIME,
        data: {
          to,
        }
      });
    }

    onInfo(title: string, message: string, to: string) {
      this.$notify({
        title,
        text: message,
        type: 'info',
        duration: NOTIFICATION_TIME,
        data: {
          to,
        }
      });
    }

    private onBackendCallOK(mutationName: string) {
      if (this.emailSendMutationNames.indexOf(mutationName) === -1) return;
      this.showEmailSendFeedback('success', 'Email enviado');
    }

    private onBackendCallKO(mutationName: string, errors: IErrors) {
      if (this.emailSendMutationNames.indexOf(mutationName) === -1) return;
      this.showEmailSendFeedback('error', 'Email no enviado', 'por error: ' + this.firstError(errors));
    }

    private showEmailSendFeedback(type: string, title: string, detail = '') {
      if (this.emailSendFeedbackTimer !== null) {
        window.clearTimeout(this.emailSendFeedbackTimer);
      }

      this.emailSendFeedback = {
        show:   true,
        type,
        icon:   type === 'success' ? 'mdi-email-check-outline' : 'mdi-email-remove-outline',
        title,
        detail,
      };

      this.emailSendFeedbackTimer = window.setTimeout(() => {
        this.emailSendFeedback.show = false;
        this.emailSendFeedbackTimer = null;
      }, EMAIL_FEEDBACK_TIME);
    }

    private firstError(errors: IErrors): string {
      if (!errors) return 'desconocido';
      const keys = Object.keys(errors);
      for (const key of keys) {
        if (errors[key] && errors[key][0]) {
          return errors[key][0];
        }
      }
      return 'desconocido';
    }

  }
